/**
 * Trigger a browser download for a blob under the given filename.
 */
export const triggerBlobDownload = (blob, filename) => {
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
};

/**
 * Run async tasks with at most `limit` in flight at once.
 * Tasks are functions returning a promise. Resolves with allSettled-shaped
 * results ({ status, value | reason }) in input order.
 */
export const runWithConcurrency = async (tasks, limit = 3) => {
    const results = new Array(tasks.length);
    let nextIndex = 0;

    const worker = async () => {
        while (nextIndex < tasks.length) {
            const index = nextIndex;
            nextIndex += 1;
            try {
                results[index] = { status: 'fulfilled', value: await tasks[index]() };
            } catch (reason) {
                results[index] = { status: 'rejected', reason };
            }
        }
    };

    await Promise.all(Array.from({ length: Math.min(limit, tasks.length) }, worker));
    return results;
};
